export const TIDS = {
  // Nav
  navLogo: "nav-logo",
  navServices: "nav-link-services",
  navProcess: "nav-link-process",
  navResults: "nav-link-results",
  navFaq: "nav-link-faq",
  navCta: "nav-cta-book-call",
  mobileMenuToggle: "nav-mobile-toggle",

  // Hero
  heroBookCall: "hero-book-call-btn",
  heroSeeResults: "hero-see-results-btn",
  heroImage: "hero-image",

  // Services
  serviceCard: (slug) => `service-card-${slug}`,

  // Stats
  statCard: (slug) => `stat-card-${slug}`,

  // Process
  processStep: (n) => `process-step-${n}`,

  // Testimonials
  testimonialCard: (n) => `testimonial-card-${n}`,

  // FAQ
  faqItem: (n) => `faq-item-${n}`,

  // Booking form
  formSection: "booking-form-section",
  inputName: "input-full-name",
  inputPractice: "input-practice-name",
  inputEmail: "input-email",
  inputPhone: "input-phone",
  inputBudget: "input-budget",
  inputDate: "input-preferred-date",
  inputTime: "input-preferred-time",
  inputMessage: "input-message",
  submitBooking: "submit-booking-btn",

  // Case studies
  caseStudyCard: (n) => `case-study-${n}`,

  // Lead magnet
  leadMagnetSection: "lead-magnet-section",
  leadMagnetEmail: "lead-magnet-email",
  leadMagnetName: "lead-magnet-name",
  leadMagnetSubmit: "lead-magnet-submit",

  // Auth / Admin
  loginEmail: "login-email",
  loginPassword: "login-password",
  loginSubmit: "login-submit",
  adminDashboard: "admin-dashboard",
  adminLogout: "admin-logout-btn",
  adminExport: "admin-export-btn",
  adminLeadRow: (id) => `admin-lead-row-${id}`,
  adminStatCard: (slug) => `admin-stat-${slug}`,

  // Footer
  footerContactLink: "footer-contact-link",
};
